import { render, staticRenderFns } from "./TimeOffMain.vue?vue&type=template&id=48828002"
import script from "./TimeOffMain.vue?vue&type=script&lang=js"
export * from "./TimeOffMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports